var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-loader-container"},[_c('div',{staticClass:"inline-loader"},[_c('div',{staticClass:"cmg-inner-div",class:_vm.spinningCircleClass})])])}
var staticRenderFns = []

export { render, staticRenderFns }